/* eslint-disable no-unused-vars */
export enum ESteps {
	WELCOME = 1,
	SEARCH_IT = 2,
	STAY_UPDATED = 3,
	ASK_AI = 4,
	SAVED = 5,
	PERSONALIZE = 6,
	ASK_QUESTIONS = 7

}